module.exports = __webpack_public_path__ + "img/7d154a1.jpg";